import React from 'react'
import { useIntl } from 'react-intl'
import { ActionButton } from '@contrast-security-inc/design-system-actions'
import { IconConfigureRule } from '@contrast-security-inc/design-system-foundations'
import { useCurrentUser } from 'contrastBase/state'

const buildUrl = (organizationUuid, applicationUuid, ruleName) =>
  `#/${organizationUuid}/applications/${applicationUuid}/protection/${ruleName}?withRule=true`

export function ProtectAction({ orgUuid, appUuid, vuln }) {
  const intl = useIntl()
  const { currentUser: { isProtectEnabled } = {} } = useCurrentUser()
  const showAction =
    isProtectEnabled && vuln && vuln?.protectStatus !== 'NO_RULE_AVAILABLE'

  // hide the action if it is not relevant/cannot be mapped
  return !showAction ? null : (
    <ActionButton
      data-testid="protect-action-button"
      onClick={() =>
        (window.location.hash = buildUrl(orgUuid, appUuid, vuln?.ruleName))
      }
      TooltipProps={{
        body: intl.formatMessage({ id: 'tooltip_mapProtectRuleToVuln' })
      }}
      IconButtonProps={{
        Icon: IconConfigureRule,
        size: 'sm',
        'aria-label': 'Map Rule'
      }}
    />
  )
}
